module.exports = __webpack_public_path__ + "static/media/cargo.cd95eadb.png";